// jquery-boot.js
// Runs deferred after jquery.min.js + owl.carousel.min.js
// Fires all $(document).ready() callbacks queued by the shim,
// then replaces the queue with a live passthrough.
(function () {
  var q = window._shimQueue;
  if (q && q.forEach) {
    q.forEach(function (fn) {
      try { fn(jQuery); } catch (e) {}
    });
  }
  window._shimQueue = { push: function (fn) { try { fn(jQuery); } catch (e) {} } };
})();
